import { render, staticRenderFns } from "./StarActive.vue?vue&type=template&id=6842d2cc&"
import script from "./StarActive.vue?vue&type=script&lang=js&"
export * from "./StarActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports